import { twMerge } from '@/lib/classname/twMerge'
import { ProgressBar as AriaProgressBar } from 'react-aria-components'
import './ProgressBar.css'

export type ProgressBarProps = UiComponentProps & {
  /** The progress value between 0 and 100 */
  value: number
  /** Accessibility label for the progress bar */
  'aria-label': string
}

export function ProgressBar({
  id,
  'data-testid': dataTestId,
  value,
  className,
  'aria-label': ariaLabel,
}: ProgressBarProps) {
  const clampedValue = Math.min(Math.max(value, 0), 100)

  return (
    <AriaProgressBar
      id={id}
      data-testid={dataTestId}
      value={clampedValue}
      aria-label={ariaLabel}
      className={twMerge(
        'h-[0.1875rem] w-full overflow-hidden bg-[var(--progress-bar-track-bg)]',
        className,
      )}
      data-slot="track"
    >
      {({ percentage }) => (
        <div
          data-slot="indicator"
          className="size-full bg-[var(--progress-bar-indicator-bg)] transition-[width] ease-out"
          style={{ width: `${percentage}%` }}
        />
      )}
    </AriaProgressBar>
  )
}
